module.exports = __webpack_public_path__ + "static/ic_sharing-c93f9c01d3f9a27d7d7d22d3320aca66.svg";